import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI
import CallEndIcon from "@mui/icons-material/CallEnd";
import { useParams } from "react-router-dom";

import AppBar from '@mui/material/AppBar';


import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { Stomp } from '@stomp/stompjs';
import ReactApexChart from "react-apexcharts";

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';
import Hls from "hls.js";

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import BarChartIcon from '@mui/icons-material/BarChart';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box, InputAdornment } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Modal from "react-modal";
import CabecalhoInformacoes from '../components/CabecalhoInformacoes/index'
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { ThemeProvider as CoreThemeProvider, createTheme as createCoreTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';

import './styles.css';


import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';
import ModuloPGMComponent from '../components/ModuloPGMComponent/index'
import ModuloSonoroComponent from '../components/ModuloSonoroComponent/index'
import CornetaComponent from '../components/CornetaComponent/index'
import CentralComponent from '../components/CentralComponent/index'
import SipCallComponent from '../components/SipCallComponent/index'
import ModuloGatewayComponent from '../components/ModuloGatewayComponent/index'
import ModuloSentinelComponent from '../components/ModuloSentinelComponent/index'
import GraficoDisponibilidade from '../../../../../components/GraficoDisponibilidade/GraficoDisponibilidade'
import PainelInstalacaoDetalhes from '../components/PainelInstalacaoDetalhes/index'

import JsSIP from 'jssip';



import api from '../../../../../services/api';


import NavegadorGestao from "../../../../../components/NavBarGestao";


import switch_off from '../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../assets/imgs/icone_call.png';


import cabo_conectado from '../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../assets/imgs/cabo_conectado.png';

import modem_conectado from '../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../configs/globalConfigs';

import CamerasComponent from '../components/CamerasComponent/index'
import PainelTriagemOcorrencias from '../components/PainelTriagemOcorrencias/index';






import "./MapPage.css";
import MapaDoLocal from './mapaLocal.js';
import alarmeAudio from '../../../../../assets/mp3/alarme.mp3';




const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'white',
    },
    toolbar: {

    },
    toolbarIcon: {

    },
    appBar: {

    },
    appBarShift: {

    },
    menuButton: {

    },
    menuButtonHidden: {

    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {

    },
    drawerPaperClose: {

    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        display: 'flex',


    },
    container: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'green',


    },
    paper: {

    },
    fixedHeight: {

    },
}));


const libraries = ["places"];


// Gerenciador de Áudio (Singleton)
const audioManager = {
    audio: new Audio(alarmeAudio),
    isPlaying: false,
    play() {
        if (!this.isPlaying) {
            this.audio.loop = true;
            this.audio.volume = 1.0;
            this.audio
                .play()
                .then(() => {
                    this.isPlaying = true;
                })
                .catch(error => console.error("Erro ao reproduzir o áudio:", error));
        }
    },
    pause() {
        if (this.isPlaying) {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.isPlaying = false;
        }
    }
};

const customStyles = {
    content: {
        top: "0", // Alinha ao topo
        left: "0", // Alinha à esquerda
        right: "auto",
        bottom: "0", // Ocupa toda a altura
        margin: "0", // Remove margens
        transform: "none", // Nenhuma transformação necessária
        width: "30%", // Ocupa 30% da largura disponível
        height: "100%", // Ocupa 100% da altura da tela
        zIndex: 9999, // Sobrepõe todas as telas
        backgroundColor: "white", // Fundo branco para o modal
        borderRadius: "0 8px 8px 0", // Bordas arredondadas apenas no lado direito
        boxShadow: "4px 0 10px rgba(0, 0, 0, 0.2)", // Sombra para dar destaque ao modal
    },
    overlay: {
        zIndex: 9998, // Sobrepõe o fundo
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro translúcido
    },
};

const customStylesMobile = {
    content: {
        top: "0", // Alinha ao topo
        left: "0", // Alinha à esquerda
        right: "auto",
        bottom: "0", // Ocupa toda a altura
        margin: "0", // Remove margens
        transform: "none", // Nenhuma transformação necessária
        width: "100%", // Ocupa 30% da largura disponível
        height: "100%", // Ocupa 100% da altura da tela
        zIndex: 9999, // Sobrepõe todas as telas
        backgroundColor: "white", // Fundo branco para o modal
        borderRadius: "0 8px 8px 0", // Bordas arredondadas apenas no lado direito
        boxShadow: "4px 0 10px rgba(0, 0, 0, 0.2)", // Sombra para dar destaque ao modal
    },
    overlay: {
        zIndex: 9998, // Sobrepõe o fundo
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro translúcido
    },
};


Modal.setAppElement("#root");


export default function MonitoramentoDashboard() {

    const { idInst, pesquisa } = useParams();

    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);
    const instalacaoSelecionadaRef = useRef(instalacaoSelecionada); // Inicialize a ref com o valor inicial do estado

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);

    const [useNativeCall, setUseNativeCall] = useState(() => {
        const saved = Cookies.get('sip_mode_native');
        return saved === 'true';
    });

    const toggleSipMode = (val) => {
        setUseNativeCall(val);
        Cookies.set('sip_mode_native', val, { expires: 365 });
    };

    // --- GLOBAL SIP LOGIC ---
    const [sipUA, setSipUA] = useState(null);
    const [sipStatus, setSipStatus] = useState('Disconnected');
    const [sipSession, setSipSession] = useState(null);
    const [activeCallRamal, setActiveCallRamal] = useState(null);
    const remoteAudioRefDashboard = useRef(new Audio());

    const sipDomain = '162.240.226.254';
    const sipUser = 'webrtc';
    const sipPassword = '1234';
    const socketUrl = 'wss://plataformagruporosinetos.com/ws';

    const handleSipHangup = useCallback(() => {
        if (sipSession) {
            sipSession.terminate();
            setSipSession(null);
            setActiveCallRamal(null);
        }
    }, [sipSession]);

    const handleSipCall = useCallback((targetRamal) => {
        if (!sipUA || !sipUA.isRegistered()) {
            alert('Sistema SIP não registrado ou desconectado.');
            return;
        }

        if (sipSession) {
            handleSipHangup();
        }

        console.log('[GLOBAL SIP] Calling:', targetRamal);
        const options = {
            mediaConstraints: { audio: true, video: false },
            pcConfig: { iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }] }
        };

        const session = sipUA.call(`sip:${targetRamal}@${sipDomain}`, options);
        setSipSession(session);
        setActiveCallRamal(targetRamal);

        session.on('peerconnection', (data) => {
            data.peerconnection.addEventListener('track', (event) => {
                const [remoteStream] = event.streams;
                if (remoteAudioRefDashboard.current) {
                    remoteAudioRefDashboard.current.srcObject = remoteStream;
                    remoteAudioRefDashboard.current.play().catch(console.error);
                }
            });
        });

        session.on('ended', () => {
            setSipSession(null);
            setActiveCallRamal(null);
        });

        session.on('failed', (e) => {
            console.error('[GLOBAL SIP] Call Failed:', e.cause);
            setSipSession(null);
            setActiveCallRamal(null);
            alert(`Falha na chamada: ${e.cause}`);
        });

    }, [sipUA, sipSession, handleSipHangup]);

    useEffect(() => {
        if (!useNativeCall) {
            if (sipUA) {
                console.log('[GLOBAL SIP] Stopping UA (Mode Disabled)');
                sipUA.stop();
                setSipUA(null);
                setSipStatus('Disconnected');
            }
            return;
        }

        if (sipUA) return;

        console.log('[GLOBAL SIP] Initializing Global UA');
        const socket = new JsSIP.WebSocketInterface(socketUrl);
        const configuration = {
            sockets: [socket],
            uri: `sip:${sipUser}@${sipDomain}`,
            password: sipPassword,
            display_name: 'Dashboard WebRTC',
            register: true
        };

        const newUa = new JsSIP.UA(configuration);

        newUa.on('connecting', () => {
            console.log('[GLOBAL SIP] Connecting...');
            setSipStatus('Connecting...');
        });
        newUa.on('connected', () => {
            console.log('[GLOBAL SIP] Connected');
            setSipStatus('Connected');
        });
        newUa.on('disconnected', (e) => {
            console.warn('[GLOBAL SIP] Disconnected:', e.error ? 'Error' : 'Normal');
            setSipStatus('Disconnected');
        });
        newUa.on('registered', () => {
            console.log('[GLOBAL SIP] Registered');
            setSipStatus('Registered');
        });
        newUa.on('registrationFailed', (e) => {
            console.error('[GLOBAL SIP] Registration Failed:', e.cause);
            setSipStatus(`Error: ${e.cause}`);
        });

        newUa.start();
        setSipUA(newUa);

        // No cleanup here that stops the UA if the component is still mounted and mode is active
        // The teardown is handled by the !useNativeCall check or the return below for unmount
        return () => {
            // This only runs on component unmount
        };
    }, [useNativeCall]);
    // Remove sipUA from dependencies to avoid re-triggering teardown on setSipUA
    // --- END GLOBAL SIP LOGIC ---

    const themeV4 = useMemo(
        () =>
            createCoreTheme({
                palette: {
                    type: darkMode ? 'dark' : 'light',
                    primary: { main: '#48D1CC' },
                    secondary: { main: '#FF4500' },
                    background: {
                        default: darkMode ? '#121212' : '#ffffff',
                        paper: darkMode ? '#1e1e1e' : '#ffffff',
                    },
                    text: {
                        primary: darkMode ? '#ffffff' : '#000000',
                        secondary: darkMode ? '#b0b0b0' : '#4f4f4f',
                    },
                },
                overrides: {
                    MuiTextField: {
                        root: {
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.23)' },
                                '&:hover fieldset': { borderColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)' },
                                '&.Mui-focused fieldset': { borderColor: darkMode ? '#ffffff' : '#48D1CC' },
                            },
                            '& .MuiInputBase-input': { color: darkMode ? '#ffffff' : 'inherit' },
                            '& .MuiInputLabel-root': { color: darkMode ? '#ffffff' : 'inherit' },
                        },
                    },
                    MuiTypography: {
                        root: {
                            color: darkMode ? '#ffffff !important' : 'inherit',
                        }
                    },
                    MuiInputBase: {
                        root: {
                            color: darkMode ? '#ffffff !important' : 'inherit',
                            '&:before': { borderBottomColor: darkMode ? '#ffffff !important' : 'inherit' },
                            '&:after': { borderBottomColor: darkMode ? '#ffffff !important' : '#48D1CC' },
                        }
                    },
                    MuiPaper: {
                        root: {
                            backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                            color: darkMode ? '#fff' : 'inherit',
                        }
                    },
                    MuiDialog: {
                        paper: {
                            backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                            color: darkMode ? '#fff' : 'inherit',
                        }
                    },
                    MuiTabs: {
                        root: {
                            backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                            color: darkMode ? '#fff' : 'inherit',
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#48D1CC',
                            }
                        }
                    },
                    MuiTab: {
                        root: {
                            color: darkMode ? '#b0b0b0' : 'inherit',
                            '&.Mui-selected': {
                                color: darkMode ? '#fff' : '#48D1CC',
                            }
                        }
                    },
                    MuiSkeleton: {
                        root: {
                            backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                        }
                    }
                },
            }),
        [darkMode],
    );

    const themeV5 = useMemo(
        () =>
            createMuiTheme({
                palette: {
                    mode: darkMode ? 'dark' : 'light',
                    background: {
                        default: darkMode ? '#121212' : '#ffffff',
                        paper: darkMode ? '#1e1e1e' : '#ffffff',
                    }
                },
            }),
        [darkMode],
    );


    const handleFiltrar = (filtro) => {
        setSearchTerm(filtro);
    }


    useEffect(() => {
        if (idInst) {
            const instalacao = { id_instalacao: idInst };
            handleInstalacaoSelecionada(instalacao);  // Passando o objeto para a função
            handleFiltrar(pesquisa);
        }
    }, []);






    const handleInstalacaoSelecionada = useCallback(async (instalacao) => {
        try {
            const token = Cookies.get("token");
            const headers = {
                Authorization: "Bearer " + token,
            };

            const response = await api.get(
                `/v1/protected/cliente/instalacoes/listarporid/${instalacao.id_instalacao}`,
                { headers }
            );
            setInstalacaoSelecionada(response.data);
            
            // Sincroniza a lista de instalações com os dados mais recentes recebidos da API
            setInstalacoes(prevInstalacoes => prevInstalacoes.map(inst => 
                inst.id_instalacao === response.data.id_instalacao ? response.data : inst
            ));
        } catch (_err) {
            console.log("Erro ao listar informações: " + _err);
        }
    }, []);



    useEffect(() => {
        if (instalacaoSelecionada !== null) {
            const interval = setInterval(() => {
                handleInstalacaoSelecionada(instalacaoSelecionada);
            }, 5000);

            return () => clearInterval(interval); // Limpa o intervalo quando o componente desmonta
        }
    }, [instalacaoSelecionada, handleInstalacaoSelecionada]);


    const audioRef = useRef(new Audio(alarmeAudio)); // Inicializar o ref com o áudio importado

    const [pgmsArmadas, setPgmsArmadas] = useState(0);
    const [pgmsDesarmadas, setPgmsDesarmadas] = useState(0);
    const [pgmsOfflines, setPgmsOfflines] = useState(0);
    const [pgmsAlarmadas, setPgmsAlarmadas] = useState(0);

    const [openMosaico, setOpenMosaico] = useState(false);
    const [cameras, setCameras] = useState([]);
    const [urlStream, setUrlStream] = useState(null);

    const [openMosaicoDisponibilidade, setOpenMosaicoDisponibilidade] = useState(false);



    const [larguraOriginal, setLarguraOriginal] = useState(0);

    const [limiar, setLimiar] = useState(900);



    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        setLarguraOriginal(largura);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    useEffect(() => {



        checkDimenssoes();



    }, []);

    const handleOpenMosaicoDisponibilidade = (url, equipamentos) => {
        setOpenMosaicoDisponibilidade(true);

    };

    const closeMosaicoDisponibilidade = () => {
        setOpenMosaicoDisponibilidade(false);

    };


    const handleOpenMosaico = (url, equipamentos) => {
        setOpenMosaico(true);
        setCameras(equipamentos);
        setUrlStream(url);
    };

    const closeMosaico = () => {
        setOpenMosaico(false);
        setCameras([]);
        setUrlStream("");
    };


    const [openGraficoDisponibilidade, setOpenGraficoDisponibilidade] = useState(false);
    const [dadosDisponibilidade, setDadosDisponibilidade] = useState(null);

    const [dadosGrafico, setDadosGrafico] = useState({
        series: [],
        options: {
            chart: {
                height: "100%",
                type: "line",
                width: "100%",
            },
            colors: ["#0288d1", "#FF5733", "#33FF57", "#5733FF", "#FFC300"], // Definição de cores diferentes para cada equipamento
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 3,
                curve: "smooth",
            },
            xaxis: {
                categories: [], // Será preenchido dinamicamente com os dias do mês
                title: {
                    text: "Dias do Mês",
                },
            },
            yaxis: {
                title: {
                    text: "Registro de Disponibilidade",
                },
            },
            markers: {
                size: 5,
                strokeColors: "#fff",
                strokeWidth: 2,
            },
            fill: {
                opacity: 1,
            },
        },
    });

    const handleOpenGraficoDisponibilidade = () => {
        listarDadosDisponibilidade();
    };

    const closeGraficoDisponibilidade = () => {
        setOpenGraficoDisponibilidade(false);
        setDadosDisponibilidade(null);
    };


    async function listarDadosDisponibilidade() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const dataAtual = new Date();
            const mes = dataAtual.getMonth() + 1; // getMonth() retorna de 0 a 11, então somamos 1
            const ano = dataAtual.getFullYear();

            await api.get("/v1/protected/registrodisponibilidade/" + instalacaoSelecionada.id_instalacao + "/" + mes + "/" + ano, {
                headers: headers
            }).then(function (response) {



                atualizarGrafico(response.data);
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            alert("Erro ao listar dados de disponibilidade!");
            console.log("Erro ao listar informações: " + _err)

        }

    }



    function atualizarGrafico(dados) {
        if (!dados || dados.length === 0) return;

        // Pegar todos os dias distintos presentes nos dados
        const dias = [...new Set(dados.map(d => d.dia))].sort((a, b) => a - b);

        // Agrupar dados por equipamento
        const equipamentos = {};

        dados.forEach((item) => {
            const id = item.id_equipamento;

            if (!equipamentos[id]) {
                equipamentos[id] = {
                    name: item.nome_mapa,
                    data: new Array(dias.length).fill(0), // Inicializa com zeros, não null
                };
            }

            // Encontrar o índice correto do dia no array ordenado
            const indexDia = dias.indexOf(item.dia);
            if (indexDia !== -1) {
                equipamentos[id].data[indexDia] = item.total_registros;
            }
        });



        setDadosGrafico({
            series: Object.values(equipamentos),
            options: {
                ...dadosGrafico.options,
                xaxis: {
                    ...dadosGrafico.options.xaxis,
                    categories: dias, // Define os dias no eixo X
                },
            },
        });

        setOpenGraficoDisponibilidade(true);
    }





    const tempoInativo = 3;

    const [mapPosition, setMapPosition] = useState(null);
    const mapPositionRef = useRef(null);

    // Atualize a referência sempre que o estado mudar
    useEffect(() => {
        instalacaoSelecionadaRef.current = instalacaoSelecionada;
        if (instalacaoSelecionada) {
            const newMapPosition = {
                lat: parseFloat(instalacaoSelecionada.latitude),
                lng: parseFloat(instalacaoSelecionada.longitude),
            };

            // Verifica se o valor atual é diferente do armazenado na ref
            if (
                !mapPositionRef.current ||
                mapPositionRef.current.lat !== newMapPosition.lat ||
                mapPositionRef.current.lng !== newMapPosition.lng
            ) {
                setMapPosition(newMapPosition);
                mapPositionRef.current = newMapPosition; // Atualiza a ref com a nova posição
            }
        }
    }, [instalacaoSelecionada]);







    const [showTable, setShowTable] = useState(true);

    const [definingPerimeter, setDefiningPerimeter] = useState(false); // Indica se está definindo perímetros
    const [perimeterPoints, setPerimeterPoints] = useState([]); // Armazena os pontos do perímetro
    const [currentPerimeter, setCurrentPerimeter] = useState(1); // Controla qual perímetro está sendo definido (P1 a P4)





    const [endereco, setEndereco] = useState();

    const [instalacoes, setInstalacoes] = useState([]);



    const [configuracoes, setConfiguracoes] = useState();
    const [loading, setLoading] = useState();
    const [loadingInstalacoes, setLoadingInstalacoes] = useState();

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/configuracoes", {
                headers: headers
            }).then(function (response) {
                setConfiguracoes(response.data);



                const logradouro = response.data.unidade_base.logradouro;
                const numero = response.data.unidade_base.numero;
                const bairro = response.data.unidade_base.bairro;
                const complemento = response.data.unidade_base.complemento;
                const cidade = response.data.unidade_base.cidade;
                const estado = response.data.unidade_base.estado;
                const cep = response.data.unidade_base.cep;

                const end = `${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado} - ${cep}`;
                setEndereco(end);
                console.log("Endereço: " + end);
                setLoading(false);


            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }






    useEffect(() => {


        listarInformacoes();


    }, []);








    function processarIcone(tipo) {
        if (tipo === 0) {
            return icone_pgm;
        } else if (tipo === 10) {
            return icone_medidor;
        } else if (tipo === 70) {
            return icone_central;
        } else if (tipo === 30) {
            return icone_pgm;
        } else if (tipo === 120) {
            return icone_corneta;
        }
    }



    function processarIconeInstalacao(tipo) {
        if (tipo === 0) {
            return icone_casa;
        } else if (tipo === 1) {
            return icone_loja;
        } else if (tipo == 2) {
            return icone_subestacao;
        }
    }






    const LocalComponent = ({ id_instalacao, lat, lng, onClick, tipo_icone, nome_mapa, status, instalacao, darkMode }) => {
        const [showMenu, setShowMenu] = useState(false);

        const status_central = instalacao.status_central;
        const now = new Date();
        const lastResponse = new Date(instalacao.data_hora_ultima_resposta);
        const differenceInMinutes = (now - lastResponse) / 1000 / 60;

        let statusText, statusColor, glowColor;
        let isAlarm = false;

        if (status_central === 2) {
            statusText = "ALARME CRÍTICO";
            statusColor = "#ef4444";
            glowColor = "rgba(239, 68, 68, 0.5)";
            isAlarm = true;
        } else if (differenceInMinutes < 3) {
            if (status_central === 1) {
                statusText = "SISTEMA PROTEGIDO";
                statusColor = "#10b981";
                glowColor = "rgba(16, 185, 129, 0.3)";
            } else {
                statusText = "SISTEMA DESARMADO";
                statusColor = "#f59e0b";
                glowColor = "rgba(245, 158, 11, 0.3)";
            }
        } else {
            let timeString = "";
            if (differenceInMinutes < 60) {
                timeString = `HÁ ${Math.floor(differenceInMinutes)} MIN`;
            } else if (differenceInMinutes < 1440) {
                timeString = `HÁ ${Math.floor(differenceInMinutes / 60)} HORAS`;
            } else {
                timeString = `HÁ ${Math.floor(differenceInMinutes / 1440)} DIAS`;
            }
            statusText = `DISPOSITIVO OFFLINE (${timeString})`;
            statusColor = "#8b5cf6";
            glowColor = "rgba(139, 92, 246, 0.3)";
        }

        const handleClickGerenciar = (e) => {
            e.stopPropagation();
            const url = `/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${id_instalacao}/0`;
            window.open(url, '_blank');
        };

        return (
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    background: darkMode ? 'rgba(30, 41, 59, 0.7)' : 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    borderLeft: `4px solid ${statusColor}`,
                    borderRadius: '12px 12px 0 0',
                    mb: 0,
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    cursor: 'pointer',
                    '&:hover': {
                        background: darkMode ? 'rgba(30, 41, 59, 0.9)' : 'rgba(255, 255, 255, 1)',
                    },
                    ...(isAlarm && {
                        animation: 'border-pulse 1.5s infinite ease-in-out'
                    })
                }}
            >
                <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ 
                            width: 48, height: 48, borderRadius: '10px', 
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: `${statusColor}15`, border: `1px solid ${statusColor}30`
                        }}>
                            <img
                                alt="icon"
                                style={{ width: 28, height: 28, filter: darkMode ? 'brightness(1.2)' : 'none' }}
                                src={processarIconeInstalacao(tipo_icone)}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{ 
                                fontWeight: 800, fontSize: '1rem', 
                                color: darkMode ? '#f1f5f9' : '#1e293b',
                                letterSpacing: '-0.2px'
                            }}>
                                {nome_mapa?.toUpperCase()}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.2 }}>
                                <div style={{ 
                                    width: 6, height: 6, borderRadius: '50%', 
                                    backgroundColor: statusColor,
                                    boxShadow: `0 0 6px ${statusColor}`
                                }} />
                                <Typography sx={{ fontSize: '0.65rem', fontWeight: 700, color: statusColor, letterSpacing: '0.5px' }}>
                                    {statusText}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Tooltip title="Gerenciar Instalação">
                        <IconButton 
                            onClick={handleClickGerenciar}
                            sx={{ 
                                color: darkMode ? '#94a3b8' : '#64748b',
                                '&:hover': { color: '#48D1CC', background: 'rgba(72, 209, 204, 0.1)' }
                            }}
                        >
                            <ManageAccountsIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>

                <style dangerouslySetInnerHTML={{ __html: `
                    @keyframes border-pulse {
                        0% { border-left-color: rgba(239, 68, 68, 0.5); }
                        50% { border-left-color: rgba(239, 68, 68, 1); }
                        100% { border-left-color: rgba(239, 68, 68, 0.5); }
                    }
                `}} />
            </Paper>
        );
    };









    const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());
    const isFirstLoadRef = useRef(true);


    const [isConnected, setIsConnected] = useState(false);

    const [numEquipamentos, setNumEquipamentos] = useState(0);
    useEffect(() => {
        let isComponentMounted = true;
        let client = null;

        const connectToWebSocket = async () => {
            const token = Cookies.get('token');
            const idUsuario = Cookies.get('id_usuario');
            const regra = Cookies.get('regra') || '';

            let idCliente = null;
            try {
                const headers = { Authorization: 'Bearer ' + token };
                const response = await api.get(`/v1/protected/user/retornardadosusuario/${idUsuario}`, { headers });
                
                if (response.data && response.data.cliente && response.data.cliente.id_cliente) {
                    idCliente = response.data.cliente.id_cliente;
                }
            } catch (error) {
                console.log("Erro ao buscar dados do cliente", error);
            }

            if (!isComponentMounted) return;

            const socket = new WebSocket(`wss://gruporosinetos.com/api/monitoramentowebsocket?token=${token}`);
            client = Stomp.over(socket);

            if (!isConnected) {
                client.connect({}, () => {
                    if (!isComponentMounted) {
                        client.disconnect();
                        return;
                    }
                    setIsConnected(true);
                    console.log('Conectado ao WebSocket');

                    let waitingNextRequest = false; // Controle de envio

                    const sendDest = idCliente ? `/app/requestData/cliente/${idCliente}` : "/app/requestData";
                    const topicDest = idCliente ? `/topic/dados/cliente/${idCliente}` : "/topic/dados";

                    // Função para enviar request
                    const sendRequest = () => {
                        if (client.connected && !waitingNextRequest) {
                            waitingNextRequest = true; // Bloqueia até receber resposta
                            client.send(sendDest, {}, JSON.stringify({}));
                        }
                    };

                    // Inscrever no tópico dinâmico
                    client.subscribe(topicDest, (message) => {
                    console.log("atualizou");
                    let num_equipamentos = 0;
                    try {
                        const dados = JSON.parse(message.body); // Parse do JSON recebido

                        //console.log(JSON.stringify(dados));

                        var num_equipamentos_armados = 0;
                        var num_equipamentos_alarmados = 0;
                        var num_equipamentos_desarmados = 0;
                        var num_equipamentos_offlines = 0;
                        const now = new Date();

                        // Percorre cada instalação
                        for (let i = 0; i < dados.length; i++) {
                            const novaInstalacao = dados[i];

                            if (novaInstalacao.equipamentos !== null) {
                                for (let p = 0; p < novaInstalacao.equipamentos.length; p++) {
                                    const novoEquipamento = novaInstalacao.equipamentos[p];
                                    if (novoEquipamento.tipo_equipamento_area_tecnica === 0 || novoEquipamento.tipo_equipamento_area_tecnica === 30) {
                                        const modulo = novoEquipamento.tipo_equipamento_area_tecnica === 0
                                            ? novoEquipamento.modulo_pgm
                                            : novoEquipamento.modulo_sonoro;

                                        const lastResponse = new Date(modulo.data_hora_ultima_resposta);
                                        const differenceInMinutes = (now - lastResponse) / 1000 / 60;
                                        const alarme = novoEquipamento.alarme;
                                        
                                        // Nova estratégia: Fallout para zonas se partição em branco (apenas para PGM)
                                        let countsAsArmed = modulo.armada;
                                        if (novoEquipamento.tipo_equipamento_area_tecnica === 0 && !modulo.status_central) {
                                            countsAsArmed = (modulo.status_zonas || "").split(";").some(l => {
                                                const p = l.split(",");
                                                if (p.length < 4) return false;
                                                const s = (p[3] || "").toLowerCase().trim();
                                                return s === "armada" || s === "true" || s === "1";
                                            });
                                        }

                                        if (alarme) {
                                            num_equipamentos_alarmados++;
                                        } else if (differenceInMinutes < tempoInativo) {
                                            if (countsAsArmed) {
                                                num_equipamentos_armados++;
                                            } else {
                                                num_equipamentos_desarmados++;
                                            }
                                        } else {
                                            num_equipamentos_offlines++;
                                        }
                                    }
                                }

                                // Fazer os sets
                                setPgmsArmadas(num_equipamentos_armados);
                                setPgmsDesarmadas(num_equipamentos_desarmados);
                                setPgmsOfflines(num_equipamentos_offlines);
                                setPgmsAlarmadas(num_equipamentos_alarmados);
                            }
                        }

                        const currentTime = Date.now();

                        const dadosSaoDiferentes = (novosDados, dadosAtuais) => {
                            if (!dadosAtuais || novosDados.length !== dadosAtuais.length) return true;

                            const syncSelecionada = (inst) => {
                                if (instalacaoSelecionadaRef.current && inst.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao) {
                                    setInstalacaoSelecionada({
                                        ...instalacaoSelecionadaRef.current,
                                        equipamentos: inst.equipamentos
                                    });
                                }
                            };

                            for (let i = 0; i < novosDados.length; i++) {
                                const novaInstalacao = novosDados[i];
                                const instalacaoAtual = dadosAtuais[i];

                                syncSelecionada(novaInstalacao);

                                if (novaInstalacao.id_instalacao !== instalacaoAtual.id_instalacao ||
                                    novaInstalacao.nome_mapa !== instalacaoAtual.nome_mapa) {
                                    syncSelecionada(novaInstalacao);
                                    return true;
                                }

                                if (!novaInstalacao.equipamentos || !instalacaoAtual.equipamentos ||
                                    novaInstalacao.equipamentos.length !== instalacaoAtual.equipamentos.length) {
                                    syncSelecionada(novaInstalacao);
                                    return true;
                                }

                                num_equipamentos += novaInstalacao.equipamentos.length;

                                for (let j = 0; j < novaInstalacao.equipamentos.length; j++) {
                                    const novoEquipamento = novaInstalacao.equipamentos[j];
                                    const equipamentoAtual = instalacaoAtual.equipamentos[j];

                                    if (novoEquipamento.id_equipamento !== equipamentoAtual.id_equipamento ||
                                        novoEquipamento.alarme !== equipamentoAtual.alarme) {
                                        syncSelecionada(novaInstalacao);
                                        return true;
                                    }

                                    if (novoEquipamento.tipo_equipamento_area_tecnica === 0) {
                                        const pgmNovo = novoEquipamento.modulo_pgm;
                                        const pgmAtual = equipamentoAtual.modulo_pgm;

                                        if (pgmNovo && pgmAtual) {
                                            if (pgmNovo.estado_armacao_modulo !== pgmAtual.estado_armacao_modulo ||
                                                pgmNovo.armada !== pgmAtual.armada ||
                                                pgmNovo.status_central !== pgmAtual.status_central ||
                                                pgmNovo.status_zonas !== pgmAtual.status_zonas ||
                                                pgmNovo.data_hora_ultima_resposta !== pgmAtual.data_hora_ultima_resposta) {
                                                syncSelecionada(novaInstalacao);
                                                return true;
                                            }

                                            for (let k = 1; k <= 4; k++) {
                                                const releKey = `status_rele${k}`;
                                                if (pgmNovo[releKey] !== pgmAtual[releKey]) {
                                                    syncSelecionada(novaInstalacao);
                                                    return true;
                                                }
                                            }
                                        } else if (pgmNovo !== pgmAtual) {
                                            syncSelecionada(novaInstalacao);
                                            return true;
                                        }
                                    } else if (novoEquipamento.tipo_equipamento_area_tecnica === 30) {
                                        const sonoroNovo = novoEquipamento.modulo_sonoro;
                                        const sonoroAtual = equipamentoAtual.modulo_sonoro;

                                        if (sonoroNovo && sonoroAtual) {
                                            if (sonoroNovo.armada !== sonoroAtual.armada ||
                                                sonoroNovo.status_central !== sonoroAtual.status_central ||
                                                sonoroNovo.status_zonas !== sonoroAtual.status_zonas ||
                                                sonoroNovo.data_hora_ultima_resposta !== sonoroAtual.data_hora_ultima_resposta) {
                                                syncSelecionada(novaInstalacao);
                                                return true;
                                            }

                                            for (let k = 1; k <= 5; k++) {
                                                const releKey = `status_rele${k}`;
                                                if (sonoroNovo[releKey] !== sonoroAtual[releKey]) {
                                                    syncSelecionada(novaInstalacao);
                                                    return true;
                                                }
                                            }
                                        } else if (sonoroNovo !== sonoroAtual) {
                                            syncSelecionada(novaInstalacao);
                                            return true;
                                        }
                                    }
                                }
                            }

                            setNumEquipamentos(num_equipamentos);
                            return false;
                        };

                        setInstalacoes((instalacoesAtuais) => {
                            const isFirst = isFirstLoadRef.current || !instalacoesAtuais || instalacoesAtuais.length === 0;

                            if (isFirst) {
                                isFirstLoadRef.current = false;
                                setLastUpdateTime(currentTime);
                                if (instalacaoSelecionadaRef.current) {
                                    const matched = dados.find(d => d.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao);
                                    if (matched) {
                                        setInstalacaoSelecionada({
                                            ...instalacaoSelecionadaRef.current,
                                            equipamentos: matched.equipamentos
                                        });
                                    }
                                }
                                return dados;
                            }

                            const shouldUpdate =
                                dadosSaoDiferentes(dados, instalacoesAtuais) ||
                                (currentTime - lastUpdateTime > 30000);

                            if (shouldUpdate) {
                                setLastUpdateTime(currentTime);
                                return dados;
                            }
                            return instalacoesAtuais;
                        });

                    } catch (error) {
                        console.error('Erro ao fazer parse dos dados:', error);
                    } finally {
                        setLoadingInstalacoes(false);
                        // Espera 5s e libera para próximo request
                        setTimeout(() => {
                            waitingNextRequest = false;
                            sendRequest();
                        }, 5000);
                    }
                });

                // Envia o primeiro request
                sendRequest();
            }, (error) => {
                console.error('Erro ao conectar ao WebSocket:', error);
            });
        }
        };

        connectToWebSocket();

        // Limpeza da conexão quando o componente for desmontado
        return () => {
            isComponentMounted = false;
            if (client && client.connected) {
                client.disconnect(() => {
                    console.log('Desconectado do WebSocket');
                });
            }
        };
    }, []); // O array vazio garante que isso será executado uma única vez

    const [searchTerm, setSearchTerm] = useState("");


    function returnDescricaoEndereco(objeto) {

        return objeto.logradouro + ", " + objeto.numero + ", bairro: " + objeto.bairro + " Complemento: " + objeto.complemento +
            "\n" + objeto.cidade + " UF: " + objeto.estado + " CEP: " + objeto.cep

    }



    const filteredInstalacoes = instalacoes
        ? instalacoes.filter((instalacao) => {
            const matchesNomeMapa =
                instalacao.nome_mapa &&
                instalacao.nome_mapa.toLowerCase().includes(searchTerm.toLowerCase());

            const matchesIdentificador =
                searchTerm &&
                instalacao.identificador_integrador &&
                String(instalacao.identificador_integrador).trim().includes(String(searchTerm).trim());


            const matchesEquipamentos = instalacao.equipamentos?.some(


                (equipamento) => {
                    const modulo = equipamento && equipamento.tipo_equipamento_area_tecnica === 0 ? equipamento.modulo_pgm
                        : (equipamento && equipamento.tipo_equipamento_area_tecnica === 30 ? equipamento.modulo_sonoro : null);

                    return equipamento &&
                        (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.tipo_equipamento_area_tecnica === 30) &&
                        modulo && ((equipamento.tipo_equipamento_area_tecnica === 0 && modulo.id_modulo_pgm > 0) || (equipamento.tipo_equipamento_area_tecnica === 30 && modulo.id_modulo_sonoro > 0)) &&
                        modulo.codigo.toLowerCase().includes(searchTerm.toLowerCase())
                }
            );



            const matchesOnline = instalacao.equipamentos?.some((equipamento) => {
                const modulo = equipamento && equipamento.tipo_equipamento_area_tecnica === 0 ? equipamento.modulo_pgm
                    : (equipamento && equipamento.tipo_equipamento_area_tecnica === 30 ? equipamento.modulo_sonoro : null);

                if (
                    equipamento &&
                    (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.tipo_equipamento_area_tecnica === 30) &&
                    modulo && ((equipamento.tipo_equipamento_area_tecnica === 0 && modulo.id_modulo_pgm > 0) || (equipamento.tipo_equipamento_area_tecnica === 30 && modulo.id_modulo_sonoro > 0))
                ) {
                    const now = new Date();
                    const lastResponse = new Date(modulo.data_hora_ultima_resposta);
                    const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

                    const alarme = equipamento.alarme;
                    const armada = modulo.armada;

                    let statusConexao;

                    if (alarme) {
                        statusConexao = "ONLINE";
                    } else if (differenceInMinutes < 3) {
                        if (armada) {
                            statusConexao = "ONLINE";
                        }
                        else {
                            statusConexao = "ONLINE";
                        }
                    } else {
                        statusConexao = "OFFLINE";
                    }


                    return statusConexao?.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            });


            const matchesStatus = instalacao.equipamentos?.some((equipamento) => {
                const modulo = equipamento && equipamento.tipo_equipamento_area_tecnica === 0 ? equipamento.modulo_pgm
                    : (equipamento && equipamento.tipo_equipamento_area_tecnica === 30 ? equipamento.modulo_sonoro : null);

                if (
                    equipamento &&
                    (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.tipo_equipamento_area_tecnica === 30) &&
                    modulo && ((equipamento.tipo_equipamento_area_tecnica === 0 && modulo.id_modulo_pgm > 0) || (equipamento.tipo_equipamento_area_tecnica === 30 && modulo.id_modulo_sonoro > 0))
                ) {
                    let countsAsArmed = modulo.armada;
                    if (equipamento.tipo_equipamento_area_tecnica === 0 && !modulo.status_central) {
                        countsAsArmed = (modulo.status_zonas || "").split(";").some(l => {
                            const p = l.split(",");
                            if (p.length < 4) return false;
                            const s = (p[3] || "").toLowerCase().trim();
                            return s === "armada" || s === "true" || s === "1";
                        });
                    }
                    const status = countsAsArmed ? "protegido" : "inseguro";
                    return status.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            });

            const matchesAlarme = instalacao.equipamentos?.some((equipamento) => {
                const modulo = equipamento && equipamento.tipo_equipamento_area_tecnica === 0 ? equipamento.modulo_pgm
                    : (equipamento && equipamento.tipo_equipamento_area_tecnica === 30 ? equipamento.modulo_sonoro : null);

                if (
                    equipamento &&
                    (equipamento.tipo_equipamento_area_tecnica === 0 || equipamento.tipo_equipamento_area_tecnica === 30) &&
                    modulo && ((equipamento.tipo_equipamento_area_tecnica === 0 && modulo.id_modulo_pgm > 0) || (equipamento.tipo_equipamento_area_tecnica === 30 && modulo.id_modulo_sonoro > 0))
                ) {
                    const alarme = equipamento.alarme ? "alarme" : "nodispar";
                    return alarme.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            });



            // Exibe a instalação se algum critério for atendido 
            return matchesIdentificador || matchesNomeMapa || matchesEquipamentos || matchesStatus || matchesAlarme || matchesOnline;
        })
        : [];


    const [openLogTable, setOpenLogTable] = useState(false);




    const options = {
        mapTypeId: 'satellite',
        streetViewControl: false, // Desativa o Street View
        fullscreenControl: false, // Desativa o controle de tela cheia
        mapTypeControl: false, // Desativa a opção de alterar o tipo de mapa
        zoomControl: true, // Ativa somente o controle de zoom
        maxZoom: 21,
        styles: [
            {
                featureType: "poi", // Oculta pontos de interesse
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "road", // Simplicidade nas rodovias
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit", // Remove transporte público
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.land_parcel", // Remove labels de terrenos
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.neighborhood", // Remove labels de bairros
                stylers: [{ visibility: "off" }],
            },
        ],
    };



    const containerStyle = {
        width: '100%',
        height: '100%'
    };



    const [map, setMap] = useState();
    const mapRef = useRef(null);

    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const [zoom, setZoom] = useState(15);


    /*
        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            item xs={12}
                            style={{ padding: 10 }}
                            spacing={1}
                        >
    
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                item
                                xs={12}
                                item xs={12} sm={6} md={6} lg={3} xl={3}
                                justifyContent={"center"}
                                style={{ backgroundColor: '#720309', padding: 5, margin: 5 }}
                            >
                                <img
                                    alt={"icone"}
                                    style={{
                                        textAlign: 'center',
                                        width: '70px', // Define a largura da imagem
                                        height: '70px' // Define a altura da imagem
                                    }}
                                    src={icone_instalacoes}
                                />
    
                                 <div style={{ textAlign: "center" }}>
                                     <span
                                        style={{
                                            fontSize: 36,
                                            color: 'white',
                                            fontWeight: 'bold',
                                            display: "block", // Para alinhar em bloco
                                            marginBottom: "1px" // Controla a distância vertical
                                        }}
                                    >
                                        {instalacoes.length}
                                    </span>
    
                                     <span
                                        style={{
                                            fontSize: 20,
                                            color: 'white',
                                            fontWeight: 'bold',
                                            paddingLeft: "10px" // Recuo horizontal para direita
                                        }}
                                    >
                                        instalações
                                    </span>
                                </div>
                            </Grid>
    
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                item
                                item xs={12} sm={6} md={6} lg={3} xl={3}
                                justifyContent={"center"}
                                style={{ backgroundColor: '#ffa424', padding: 5, margin: 5 }}
                            >
                                <img
                                    alt={"icone"}
                                    style={{
                                        textAlign: 'center',
                                        width: '70px', // Define a largura da imagem
                                        height: '70px' // Define a altura da imagem
                                    }}
                                    src={icone_equipamentos}
                                />
    
                              
                                <div style={{ textAlign: "center" }}>
                                     <span
                                        style={{
                                            fontSize: 36,
                                            color: 'white',
                                            fontWeight: 'bold',
                                            display: "block", // Para alinhar em bloco
                                            marginBottom: "1px" // Controla a distância vertical
                                        }}
                                    >
                                        {numEquipamentos}
                                    </span>
    
                                     <span
                                        style={{
                                            fontSize: 20,
                                            color: 'white',
                                            fontWeight: 'bold',
                                            paddingLeft: "10px" // Recuo horizontal para direita
                                        }}
                                    >
                                        equipamentos
                                    </span>
                                </div>
                            </Grid>
    
    
                        </Grid>
    */


    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>

                <div style={{ backgroundColor: themeV4.palette.background.default, minHeight: '100vh', color: themeV4.palette.text.primary }} >
                    <NavegadorGestao
                        AreaTecnica={true}
                        Monitoramento={true}
                        MonitoramentoDashboard={true}
                        corFundo={darkMode ? '#333' : 'white'} travado={true} corTexto={darkMode ? 'white' : 'black'}
                    />

                    {loading ? (
                        <Skeleton animation={"wave"} style={{ backgroundColor: '#48D1CC' }} />
                    ) : (
                        <>
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                item xs={12}
                            >

                                <CabecalhoInformacoes
                                    pgmsArmadas={pgmsArmadas}
                                    pgmsDesarmadas={pgmsDesarmadas}
                                    pgmsOfflines={pgmsOfflines}
                                    pgmsAlarmadas={pgmsAlarmadas}
                                    filtrar={handleFiltrar}
                                    useNativeCall={useNativeCall}
                                    setUseNativeCall={toggleSipMode}
                                    sipStatus={sipStatus}
                                />

                            <Grid
                                container
                                direction="column"
                                item xs={12}
                                sx={{ gap: 2 }}
                            >
                                {/* Pesquisa Estilizada */}
                                <TextField
                                    fullWidth
                                    placeholder="BUSCAR INSTALAÇÃO OU DISPOSITIVO..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    variant="outlined"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ color: darkMode ? '#48D1CC' : '#0f172a' }} />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            background: darkMode ? 'rgba(30, 41, 59, 0.5)' : 'rgba(255, 255, 255, 0.8)',
                                            backdropFilter: 'blur(8px)',
                                            borderRadius: '12px',
                                            fontWeight: 700,
                                            fontSize: '0.8rem',
                                            letterSpacing: '1px',
                                            transition: 'all 0.3s ease',
                                            border: `1px solid ${darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
                                            '&:hover': {
                                                background: darkMode ? 'rgba(30, 41, 59, 0.7)' : 'rgba(255, 255, 255, 1)',
                                            },
                                            '&.Mui-focused': {
                                                border: '1px solid #48D1CC',
                                                boxShadow: '0 0 15px rgba(72, 209, 204, 0.2)'
                                            }
                                        }
                                    }}
                                />

                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ alignItems: 'stretch' }}
                                >
                                    <Grid
                                        item xs={12} sm={6} md={5} lg={4}
                                        sx={{ 
                                            display: 'flex', flexDirection: 'column', gap: 1.5,
                                            maxHeight: 'calc(100vh - 300px)', overflowY: 'auto',
                                            pr: 1,
                                            '&::-webkit-scrollbar': { width: '4px' },
                                            '&::-webkit-scrollbar-thumb': { background: '#48D1CC30', borderRadius: '10px' }
                                        }}
                                    >
                                        {!loadingInstalacoes && instalacoes && filteredInstalacoes.map((instalacao) => (
                                            <Box
                                                key={instalacao.id_instalacao}
                                                onClick={() => setInstalacaoSelecionada(instalacao)}
                                                sx={{
                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                    mb: 4,
                                                    p: 0.5,
                                                    borderRadius: '16px',
                                                    background: instalacaoSelecionada?.id_instalacao === instalacao.id_instalacao 
                                                        ? (darkMode ? 'rgba(72, 209, 204, 0.08)' : 'rgba(72, 209, 204, 0.04)')
                                                        : 'transparent',
                                                    border: `1px solid ${instalacaoSelecionada?.id_instalacao === instalacao.id_instalacao 
                                                        ? '#48D1CC' 
                                                        : (darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)')}`,
                                                    boxShadow: instalacaoSelecionada?.id_instalacao === instalacao.id_instalacao 
                                                        ? `0 8px 32px -8px rgba(72, 209, 204, 0.2)` 
                                                        : 'none',
                                                    '&:hover': {
                                                        background: instalacaoSelecionada?.id_instalacao === instalacao.id_instalacao 
                                                            ? (darkMode ? 'rgba(72, 209, 204, 0.12)' : 'rgba(72, 209, 204, 0.06)')
                                                            : (darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)'),
                                                        borderColor: instalacaoSelecionada?.id_instalacao === instalacao.id_instalacao 
                                                            ? '#48D1CC' 
                                                            : (darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'),
                                                    }
                                                }}
                                            >
                                                <LocalComponent
                                                    id_instalacao={instalacao.id_instalacao}
                                                    tipo_icone={instalacao.icone_mapa}
                                                    nome_mapa={instalacao.nome_mapa}
                                                    instalacao={instalacao}
                                                    darkMode={darkMode}
                                                />
                                                
                                                <Grid
                                                    container
                                                    spacing={1}
                                                    sx={{
                                                        background: darkMode ? 'rgba(15, 23, 42, 0.6)' : 'rgba(248, 250, 252, 0.9)',
                                                        backdropFilter: 'blur(10px)',
                                                        borderRadius: '0 0 12px 12px',
                                                        mt: 0, pt: 2, pb: 2, px: 2,
                                                        width: '100% !important',
                                                        margin: '0 !important'
                                                    }}
                                                >
                                                    {instalacao.equipamentos.map((equipamento) => (
                                                        <React.Fragment key={equipamento.id_equipamento}>
                                                            {equipamento?.tipo_equipamento_area_tecnica === 0 && equipamento?.modulo_pgm?.id_modulo_pgm > 0 && (
                                                                <ModuloPGMComponent tipo={0} equipamento={equipamento} flag={0} />
                                                            )}
                                                            {equipamento?.tipo_equipamento_area_tecnica === 70 && (
                                                                <CentralComponent tipo={70} equipamento={equipamento} flag={0} />
                                                            )}
                                                            {equipamento?.tipo_equipamento_area_tecnica === 30 && equipamento?.modulo_sonoro?.id_modulo_sonoro > 0 && (
                                                                <ModuloSonoroComponent 
                                                                    tipo={30} equipamento={equipamento} flag={0}
                                                                    useNativeCall={useNativeCall} setUseNativeCall={toggleSipMode} sipStatus={sipStatus}
                                                                    onSipCall={handleSipCall} onSipHangup={handleSipHangup}
                                                                />
                                                            )}
                                                            {equipamento?.tipo_equipamento_area_tecnica === 5 && (
                                                                <ModuloGatewayComponent tipo={5} equipamento={equipamento} flag={0} />
                                                            )}
                                                            {equipamento?.tipo_equipamento_area_tecnica === 8 && (
                                                                <ModuloSentinelComponent tipo={8} equipamento={equipamento} flag={0} />
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        ))}
                                    </Grid>

                                    <Grid
                                        item xs={12} sm={6} md={7} lg={8}
                                        sx={{ 
                                            position: 'relative',
                                            minHeight: '400px',
                                            borderRadius: '16px',
                                            overflow: 'hidden',
                                            border: `1px solid ${darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
                                            background: darkMode ? 'rgba(15, 23, 42, 0.4)' : 'rgba(248, 250, 252, 0.8)',
                                            backdropFilter: 'blur(10px)'
                                        }}
                                    >
                                        <PainelTriagemOcorrencias onSelectInstalacao={handleInstalacaoSelecionada} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {instalacaoSelecionada && (
                            <PainelInstalacaoDetalhes
                                instalacaoSelecionada={instalacaoSelecionada}
                                setInstalacaoSelecionada={setInstalacaoSelecionada}
                                larguraOriginal={larguraOriginal}
                                limiar={limiar}
                                darkMode={darkMode}
                                activeCallRamal={activeCallRamal}
                                handleSipHangup={handleSipHangup}
                                handleSipCall={handleSipCall}
                                returnDescricaoEndereco={returnDescricaoEndereco}
                                handleOpenGraficoDisponibilidade={handleOpenGraficoDisponibilidade}
                                useNativeCall={useNativeCall}
                                toggleSipMode={toggleSipMode}
                                sipStatus={sipStatus}
                                handleOpenMosaicoDisponibilidade={handleOpenMosaicoDisponibilidade}
                                handleOpenMosaico={handleOpenMosaico}
                                openMosaico={openMosaico}
                                closeMosaico={closeMosaico}
                                cameras={cameras}
                                urlStream={urlStream}
                                openMosaicoDisponibilidade={openMosaicoDisponibilidade}
                                closeMosaicoDisponibilidade={closeMosaicoDisponibilidade}
                            />
                        )}

                            {/* Modal Gráfico de Disponibilidade */}
                            {openGraficoDisponibilidade && instalacaoSelecionada && (
                                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 99999 }}>
                                    <GraficoDisponibilidade
                                        idInstalacao={instalacaoSelecionada.id_instalacao}
                                        onClose={closeGraficoDisponibilidade}
                                    />
                                </div>
                            )}



                        </>
                    )}
                    <audio ref={remoteAudioRefDashboard} hidden />
                </div>
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}
